// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/loading-button.js
import BaseComponent from "./base_component"

export default class LoadingButton extends BaseComponent {
  static componentName = "loading-button"
  static defaults = { timeout: 2000, spinnerType: "border" }

  constructor(element, config = {}) {
    super(element, config)
    this.originalContent = element.innerHTML
  }

  start() {
    if (this.loading || this.element.disabled) return
    this.loading = true
    this.element.disabled = true
    this.element.classList.add("disabled")
    this.element.setAttribute("aria-disabled", "true")
    this.element.innerHTML = `<span class="spinner-${this.config.spinnerType} spinner-${this.config.spinnerType}-sm" aria-hidden="true"></span><span class="visually-hidden">Loading...</span>`
    if (this.config.timeout) this.timeout = setTimeout(() => this.stop(), this.config.timeout)
  }

  stop() {
    clearTimeout(this.timeout)
    this.loading = false
    this.restoreAttribute("disabled")
    this.element.classList.toggle("disabled", this.originalClassName.split(" ").includes("disabled"))
    this.restoreAttribute("aria-disabled")
    this.element.innerHTML = this.originalContent
  }

  dispose() {
    if (this.signal.aborted) return
    this.stop()
    super.dispose()
  }
}
